<div class="flex flex-col gap-6">
	<h2>Cotizaciones</h2>

	@if (loading()) {
		<app-quotes-table-skeleton
			[showProducer]="canShowProducer"
			[showUser]="false"
			class="w-full" />
	} @else {
		<app-quotes-table
			[showUser]="false"
			[entities]="rows()"
			[showProducer]="canShowProducer"
			(viewDetail)="openDetail($event)" />

		<app-pagination
			[paginationStore]="paginationStore"
			(pageChange)="changePage()" />
	}
</div>

<app-quotes-sidebar />
